export default {
  init() {
    const navbar = (function () {
      const $bodyEl = $('body');
      const $navOpenEl = $('#navOpen');
      const $navCloseEl = $('#navClose');
      const $mainNavEl = $('#navbarToggleExternalContent');

      const _openNav = function () {
        $bodyEl.addClass('nav-opened');
        $mainNavEl.addClass('show');
      };

      const _closeNav = function () {
        $bodyEl.removeClass('nav-opened');
        $mainNavEl.removeClass('show');
      };

      const handleNav = function () {
        $navOpenEl.on('click', function () {
          _openNav();
        });
        $navCloseEl.on('click', function () {
          _closeNav();
        });
      };

      const run = function () {
        handleNav();
      };

      return { run };
    })();

    const header = (function () {
      const $headerEl = $('header');
      let latestScrollY = 0;
      let scheduledAnimationFrame = false;

      const _updateHeader = function () {
        const currentScrollY = latestScrollY;
        const $internalMenuEl = $('.block-internal-menu');

        if (currentScrollY > 0) {
          if (!$headerEl.hasClass('header--sticky')) {
            $headerEl.addClass('header--sticky');
          }
        } else {
          $headerEl.removeClass('header--sticky');
        }

        // Update position of the internal menu if needed
        if ($internalMenuEl.length) {
          const headerHeight = $headerEl.height();
          $internalMenuEl.css({
            top: headerHeight,
          });
        }
        scheduledAnimationFrame = false;
      };

      const _requestTick = function () {
        if (scheduledAnimationFrame) {
          return;
        }
        scheduledAnimationFrame = true;
        requestAnimationFrame(_updateHeader);
      };

      const _onScroll = function () {
        latestScrollY = window.scrollY;
        _requestTick();
      };

      const handleScroll = function () {
        window.addEventListener('scroll', _onScroll);
      };

      const run = function () {
        handleScroll();
      };

      return { run };
    })();

    $(function () {
      navbar.run();
      header.run();
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    if (!window.minHeightSet) {
      $('body > .wrap').css({'min-height': 'calc(100vh - ' + ($('body > header').height() + $('body > footer').height() - 25) + 'px)'})
      window.minHeightSet = true;
    }

    const updateMenuIndex = function() {
      $('.nav-primary ul li.menu-item:visible').each(function(idx) {
        if (!window.meta_object.logged_in && $(this).find('[href*="logout=1"]').length) {
          $(this).hide();
        }
        else {
          $(this).attr('data-before', (idx + 1).toString().padStart(2,'0'));
        }
      });
    }

    updateMenuIndex();
    $(window).on('resize', updateMenuIndex);
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js